import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { RouterModule } from '@angular/router'
import { BackButtonComponent } from '../buttons/back-button/back-button.component'

export interface TitleNavigationLinks {
  label: string
  route: string
  queryParams?: { [key: string]: unknown }
}

@Component({
  selector: 'lib-title-navigation',
  imports: [RouterModule, MatButtonModule, BackButtonComponent],
  templateUrl: './title-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './title-navigation.component.scss',
})
export class TitleNavigationComponent {
  links = input<TitleNavigationLinks[]>([])
}
